export const DICT = {
  sv: {
    title: "Scoutkåren Vasa Korsfarare",
      welcome: "Välkommen! 🌲",
      files: "Filer",
      todo: "To-do",
      inventory: "Inventarie",
      website: "Hemsidan",
      topTodo: "Högsta prioritet",
      language: "Språk: Svenska",
      languageBtn: "Byt till engelska",
      loading: "Laddar...",
      none: "Inget att visa",
      openTodo: "Öppna To-do",
      back:"Tillbaka",

    //file
    fileSystem: "Filsystem",
    up: "Bakåt",
    uploadFile: "Ladda upp fil",
    uploadFolder: "Ladda upp mapp",
    name: "Namn",
    date: "Datum",
    tags: "Tags",
    actions: "Åtgärder",    
    showtagfilter: "Visa tag-filter",
    remove:"Rensa",
    root:"Början",
    hidetagfilter:"Dölj tag-filter",
    choosetags:"Välj en eller flera tags",
    matchtags:"Matcha alla valda tags",
    gouptitle:"Gå bakåt en nivå",
    confirmdelete:"Ta bort",
    fetchError:"Något gick fel vid hämtning av filer.",
    noFiles:"Inga filer här ännu.",
    cancel:"Avbryt",
    choosefile:"Välj fil",
    choosefolder:"Välj folder",
    pickFile: "Välj fil",
    pickFolder: "Välj mapp",
    nothingChosen: "Inget valt",
    filesChosen: "filer valda",
    tagPlaceholder: "t.ex. möte, 2026",
    commaSeparated: "Komma-separerat",
    upload: "Ladda upp",
    chooseonefile:"Välj minst en fil först",
    items:"Objekt",
    tagex:"möte, 2026",

    //todo
    todoTitle: "To-do-lista",
    toggleClose: "Stäng",
    toggleCreate: "Skapa ny uppgift",
    sortByPrio: "Sortera enligt prioritet",
    titlePh: "Titel (t.ex. mera batterier)",
    descPh: "Kort beskrivning…",
    namePh: "Namn (vem lade till?)",
    prioLabel: "Prioritet",
    add: "Lägg till",
    empty: "Allt gjort, slay!🌲",
    creator: "Skapare",
    unknown: "Okänd",


    //inv
    invTitle: "Inventarielista",
    scoutHq: "Kårlokalen",
    cabin: "Sportstugan",
    compareYears: "Jämför år:",
    downloadCsv: "Ladda ner lista (CSV)",
    addItem: "Lägg till sak",
    loadingInv: "Laddar...",
    invFetchError: "Kunde inte hämta inventarie",
    chooseCategoryErr: "Välj en kategori",
    couldNotAddItem: "Kunde inte lägga till sak",

    things: "Saker",
    category: "Kategori",
    chooseCategory: "Välj kategori…",
    qty: "Antal",
    status: "Status",
    place: "Plats",
    year: "År",
    save: "Spara",
    close: "Stäng",
    delete: "Radera",
    clickToEdit: "Klicka för att ändra",
    emptyCategory: "Här finns det inget! Dags att shoppa!",
    nowQty: "Antal nu",
    addItemTitle: "Lägg till sak",
    thingPlaceholder: "t.ex. Tält 4-personers",
    statusPlaceholder: "t.ex. Bra / Okej / Behöver fyllas på",
    placeLabel: "Plats",
    yearLabel: "År",
    placeNow: "Plats",
    yearNow: "År",
    catLabel: "Kategori",
    qtyNow: "Antal nu",
    confirmRowDelete: "Antalet blir 0. Vill du radera raden?",
    confirmDeleteYear: (name, year) => `Radera "${name}" för år ${year}?`,
    couldNotUpdate: "Kunde inte uppdatera",
    couldNotDelete: "Kunde inte radera",
    cat_equipment: "Utrustning",
    cat_kitchen: "Kök",
    cat_tools: "Verktyg",
    cat_tents: "Tält",
    cat_other: "Övrigt",

  },
  en: {
    title: "Scoutkåren Vasa Korsfarare",
      welcome: "Welcome! 🌲",
      files: "Files",
      todo: "To-do",
      inventory: "Inventory",
      website: "Website",
      topTodo: "Top priority",
      language: "Language: English",
      languageBtn: "Switch to Swedish",
      loading: "Loading...",
      none: "Nothing to show",
      openTodo: "Open To-do",
      back:"Back",
 
    //file
    fileSystem: "File system",
    up: "Up",
    uploadFile: "Upload file",
    uploadFolder: "Upload folder",
    name: "Name",
    date: "Date",
    tags: "Tags",
    actions: "Actions",
    showtagfilter:"Show tag-filter",
    remove:"Remove",
    root:"Root",
    hidetagfilter:"Hide tag-filter",
    choosetags:"Choose one or more tags",
    matchtags:"Match all chosen tags",
    gouptitle:"Go back one level",
    confirmdelete:"Delete",
    fetchError:"Something went wrong",
    noFiles:"No files here",
    cancel:"Cancel",
    choosefile:"Choose file",
    choosefolder:"Choose folder",
    pickFile: "Choose file",
    pickFolder: "Choose folder",
    nothingChosen: "Nothing chosen",
    filesChosen: "files chosen",
    tagPlaceholder: "e.g. meeting, 2026",
    commaSeparated: "Comma-separated",
    upload: "Upload",
    chooseonefile:"Choose at least one file",
    items:"Items",
    tagex:"meeting, 2026",

    //todo
    todoTitle: "To-do list",
    toggleClose: "Close",
    toggleCreate: "Create new task",
    sortByPrio: "Sort by priority",
    titlePh: "Title (e.g. more batteries)",
    descPh: "Short description…",
    namePh: "Name (who added it?)",
    prioLabel: "Priority",
    add: "Add",
    empty: "All done! 🌲",
    creator: "Creator",
    unknown: "Unknown",

    //inv
    invTitle: "Inventory list",
    scoutHq: "Scout HQ",
    cabin: "Cabin",
    compareYears: "Compare years:",
    downloadCsv: "Download list (CSV)",
    addItem: "Add item",
    loadingInv: "Loading...",
    invFetchError: "Could not fetch inventory",
    chooseCategoryErr: "Choose a category",
    couldNotAddItem: "Could not add item",
    things: "Items",
    category: "Category",
    chooseCategory: "Choose category…",
    qty: "Quantity",
    status: "Status",
    place: "Location",
    year: "Year",
    save: "Save",
    close: "Close",
    delete: "Delete",
    clickToEdit: "Click to edit",
    emptyCategory: "Nothing here yet!",
    nowQty: "Current qty",
    addItemTitle: "Add item",
    thingPlaceholder: "e.g. 4-person tent",
    statusPlaceholder: "e.g. Good / OK / Needs refill",
    placeLabel: "Location",
    yearLabel: "Year",
    placeNow: "Location",
    yearNow: "Year",
    catLabel: "Category",
    qtyNow: "Current qty",
    confirmRowDelete: "Quantity will become 0. Do you want to delete the row?",
    confirmDeleteYear: (name, year) => `Delete "${name}" for year ${year}?`,
    couldNotUpdate: "Could not update",
    couldNotDelete: "Could not delete",
    cat_equipment: "Equipment",
    cat_kitchen: "Kitchen",
    cat_tools: "Tools",
    cat_tents: "Tents",
    cat_other: "Other",
    

  },
};